import { FormSubmitButton } from '../../components/Button/PrimaryButton';
import { FormComponent } from '../../components/FormCom/FormComponent';
import { TextInputField } from '../../components/FormCom/FormField';
import useAuth from '../../hooks/useAuth';
import {
  resetPasswordInitialValues,
  ResetPaswdDataType,
  ResetPaswdSchema,
} from '../../models/auth/resetPassword.model';

export const ResetPassword = () => {
  const { passwordReset, loading } = useAuth();

  const onSubmit = async (values: ResetPaswdDataType) => {
    passwordReset(values);
  };

  return (
    <FormComponent
      initialValues={resetPasswordInitialValues}
      schema={ResetPaswdSchema}
      onSubmit={onSubmit}
    >
      <TextInputField
        label="Email"
        name="email"
        type="email"
        placeholder="Email"
      />

      <FormSubmitButton type="submit" showIcon={loading}>
        Reset
      </FormSubmitButton>
    </FormComponent>
  );
};
